/**
 * @fileoverview Agent definition for draft-all-chapters.
 *
 * This is a COMPOSITE agent that sequentially walks through all eligible chapters
 * in a project and processes each one using:
 * - chapter-drafter-v2: Standard chapter drafting (targets Planned chapters)
 * - chapter-drafter-enhanced-v2: Draft + automatic refinement (targets Planned chapters)
 * - draft-refiner-v2: Refine existing content (targets Being Written chapters)
 *
 * The action type determines which chapters are eligible. The same configuration
 * (model, instructions, style guide) is applied to every chapter. Chapters are
 * processed sequentially so each chapter's context includes freshly written/refined
 * content from prior chapters.
 *
 * @category writing.content.generation
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { HookInputSchema, OutputSchema } from './schema';
// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'draft-all-chapters',
  kind: 'composite',
  name: 'Draft All Chapters',
  description: 'Sequentially processes all eligible chapters using the chapter drafter, enhanced chapter drafter, or draft refiner, applying the same configuration to each.',
  category: 'writing',
  inputSchema: HookInputSchema,
  outputSchema: OutputSchema,

  // --- Metadata ---
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    usedBy: [
      'use-draft-all-chapters.ts',
    ],
    composedOf: [
      'chapter-drafter-v2',
      'chapter-drafter-enhanced-v2',
      'draft-refiner-v2',
    ],
    relatedAgents: ['chapter-drafter-v2', 'chapter-drafter-enhanced-v2', 'draft-refiner-v2'],
    taxonomyPath: 'writing.content.generation',
  },
};
